import { createTaskBaseFileStore } from "./createTaskBaseFileStore";
import { requestDownloadFullOfferZip, requestZipFullOfferDownload } from "api/offer.api";
import { Offer } from "pages/project/offer/offer.typing";

export const useOfferFileStore = createTaskBaseFileStore<Offer>(
  "offer",
  (offer, currentLanguage, hubConnectionId) => requestZipFullOfferDownload(offer.id, currentLanguage, hubConnectionId),
  (id, guid) => requestDownloadFullOfferZip(id, guid)
);
